// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__Gp8nL","label":"CategoryService_label__1Qn6b","location":"CategoryService_location__e_ju6"};